import { render, staticRenderFns } from "./InventoryWorth.vue?vue&type=template&id=44517564&scoped=true"
import script from "./InventoryWorth.vue?vue&type=script&lang=js"
export * from "./InventoryWorth.vue?vue&type=script&lang=js"
import style0 from "./InventoryWorth.vue?vue&type=style&index=0&id=44517564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44517564",
  null
  
)

export default component.exports